import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import IconButton from 'components/atoms/Button/IconButton';
import NormalButton from 'components/atoms/Button/NormalButton';
import { disableAllMenu, activeModal } from 'modules/actions/statusMenu';
import { chatList } from 'modules/actions/chat';
import { sendComplaint } from 'modules/actions/sendComplaint';
import { getComplaintTypeInfo } from 'modules/actions/getComplaintTypeInfo';
import { setResponse } from 'modules/actions/quality';
import './style.scss';

const Complaint = () => {
  const complaintResult = useSelector((state) => state.complaintResult);
  const complaintTypeResult = useSelector((state) => state.complaintTypeResult);
  const chatResult = useSelector((state) => state.chatList);

  const dispatch = useDispatch();

  const location_ref = useRef();
  const call_ref = useRef();
  const main_type_ref = useRef();
  const type_code_ref = useRef();
  const type_ref = useRef();
  const content_ref = useRef();
  const contentLen_ref = useRef();
  let initial_content_ref = '';

  const [agreeYN, setAgree] = useState('N');
  const [alertText, setAlertText] = useState('-');
  const [alertClass, setAlertClass] = useState('d-none');
  const [searchLoc, setSearchLoc] = useState('');
  const [selectedLoc, setSelectedLoc] = useState('');
  const [selectedRegion, setSelectedRegion] = useState('');

  // useEffect(() => {
  //   if (location_ref.current) {
  //     location_ref.current.focus();
  //   }
  // }, []);

  useEffect(() => {
    let typeText = '';
    let botChat = chatResult.data.filter((obj) => obj.chatType === 'bot');
    botChat = botChat.filter((obj) => obj.data.template_id);
    if (
      botChat[botChat.length - 1].data.messages[0] &&
      botChat[botChat.length - 1].data.messages[0].id === 'complaints_tem'
    ) {
      if (botChat[botChat.length - 1].data.messages[0].items[0]) {
        typeText =
          botChat[botChat.length - 1].data.messages[0].items[0].type.value;
      }
    }
    dispatch(getComplaintTypeInfo({ searchText: typeText }));
  }, [chatResult]);

  useEffect(() => {
    const result = complaintTypeResult.typeInfo;
    main_type_ref.current.value = result.main_type;
    type_code_ref.current.value = result.type_code;
    type_ref.current.value = result.sub_type;
    content_ref.current.value = result.content;
    initial_content_ref = result.content;
    setTextareaLen();
  }, [complaintTypeResult.typeInfo]);

  useEffect(() => {
    const complaint_loading = document.getElementById('complaint_loading');
    if (complaintResult.result === '200') {
      setAlertClass('d-none');
      endComplaint('민원접수종료', '민원 접수 종료');
      showMsg(complaintResult.msg);
    } else if (complaintResult.result === '100') {
      setAlertClass('text-danger text-bold');
      setAlertText('민원 접수에 실패하였습니다. 다시 시도해 주세요.');
    } else if (complaintResult.result === '400') {
      setAlertClass('text-danger text-bold');
      setAlertText('민원 접수에 실패하였습니다. 다시 시도해 주세요.');
    } /* else if (dialgoueResult.result === '500') {
      setAlertClass('text-danger text-bold');
      setAlertText('민원 접수에 실패하였습니다. 다시 시도해 주세요.');
    } */

    complaint_loading.style.display = 'none';
  }, [complaintResult.result]);

  const setTextareaLen = () => {
    let locationLen = location_ref.current.value.length;
    let contentLen = content_ref.current.value.length;

    if (locationLen > 26) {
      location_ref.current.value = location_ref.current.value.substring(0, 26);
      locationLen = 26;
    }
    if (contentLen > 1000) {
      content_ref.current.value = content_ref.current.value.substring(0, 1000);
      contentLen = 1000;
    }
    location_ref.current.innerHTML = locationLen;
    contentLen_ref.current.innerHTML = contentLen;
  };

  const onKeyPressEvt = (e) => {
    const target = e.target.id;
    const invalidCharacters = ['-', '*', '.'];
    if (target === '_cont_call' && invalidCharacters.includes(e.key)) {
      e.preventDefault();
    }
    if (e.key === 'Enter' && !e.shiftKey) {
      getMapLocation();
      checkAgree();
    }
  };

  const onAgreeChange = (e) => {
    setAgree(e.target.value);
  };

  const checkRegExp = (str, type = 'default') => {
    let isSafe = false;
    if (type === 'call') {
      const callReg = new RegExp(/[^0-9-]/gi);
      //  const callReg = new RegExp(/[^\d-]/gi);
      isSafe = !callReg.test(str);
    } else if (type === 'text') {
      const textReg = new RegExp(/[^0-9a-zA-Zㄱ-힣/()\s]/gi);
      isSafe = !textReg.test(str);
    } else {
      const defaultReg = new RegExp(/[^0-9a-zA-Zㄱ-힣-?!*:;.,()[\]@/~\s]/gi);
      isSafe = !defaultReg.test(str);
    }

    return isSafe;
  };

  const checkAgree = (e) => {
    const complaint_loading = document.getElementById('complaint_loading');
    setAlertText('');
    const isLoc = selectedLoc !== '' && checkRegExp(selectedLoc);
    const isContent =
      content_ref.current.value !== '' &&
      checkRegExp(content_ref.current.value);
    const isCall =
      call_ref.current.value !== '' &&
      checkRegExp(call_ref.current.value, 'call');
    const isAddrText = location_ref.current.value !== '';

    const callOnlyNumber = call_ref.current.value.replace(/-/g, '');
    const isCallLen = callOnlyNumber.length === 11;
    const isAgree = agreeYN === 'Y';

    setAlertClass('text-danger text-bold');
    if (!isLoc) {
      setAlertText('※ 지도를 클릭하여 민원 발생 위치를 지정해주세요.');
    } else if (!isAddrText) {
      setAlertText(
        '※ 입력된 주소가 없습니다. 지도를 클릭하여 민원 발생 위치를 지정해주세요.'
      );
    } else if (selectedRegion.substring(0, 3) !== '용인시') {
      setAlertText(
        '※ 용인시의 신고만 접수 가능합니다. 지도를 클릭하여 용인시의 민원 발생 위치를 지정해주세요.'
      );
    } else if (!isCall) {
      setAlertText('※ 휴대폰번호 형식을 확인해 주세요.\n 예시) 01011112222');
    } else if (!isCallLen) {
      setAlertText('※ 휴대폰번호 자릿 수를 확인해 주세요.\n 예시) 01011112222');
    } else if (!isAgree) {
      setAlertText('※ 개인정보 수집·이용 동의는 필수입니다.');
    } else {
      const confirmText = `
- 신고장소 : ${location_ref.current.value}
- 휴대폰 번호 : ${call_ref.current.value}
- 유형 : ${type_ref.current.value}

위 내용으로 민원을 접수하시겠습니까?`;
      const sign = window.confirm(confirmText);
      if (sign) {
        complaint_loading.style.display = '';
        setAlertClass('d-none');

        /*
        const subTypeValue = type_ref.current?.value.trim();
        let regionValue = selectedRegion.replace('용인시 ', '');

        if (subTypeValue === '공원가로등') {
          regionValue = '푸른공원 사업소';
        }
        */

        dispatch(
          sendComplaint({
            call: call_ref.current.value,
            addr: selectedLoc,
            // region: selectedRegion.replace('용인시 ', ''),
            // region: type_ref.include('공원가로등') ? '푸른공원 사업소' : selectedRegion.replace('용인시 ', '')
            region:
              type_ref.current?.value === '공원가로등'
                ? '푸른공원 사업소'
                : selectedRegion.replace('용인시 ', ''),
            type_code: type_code_ref.current.value,
            main_type: main_type_ref.current.value,
            sub_type: type_ref.current?.value.trim(),
            content: content_ref.current?.value.trim(),
            status: false,
          })
        );
      }
    }
  };

  const endComplaint = (inStr, inLabel) => {
    const paramSet = {
      inType: 'query',
      inStr,
      inLabel,
      parameters: sessionStorage.getItem('address')
        ? {
            latitude_y: sessionStorage.getItem('latitude_y'),
            longitude_x: sessionStorage.getItem('longitude_x'),
            address: sessionStorage.getItem('address'),
            position_status: 'Y',
          }
        : { latitude_y: '', longitude_x: '', position_status: 'N' },
      responseHidden: 'Y',
    };
    dispatch(sendComplaint({ status: 'stop' }));
    dispatch(chatList(paramSet));
    dispatch(disableAllMenu());
  };

  const showMsg = (msg) => {
    dispatch(setResponse(msg));
    dispatch(activeModal('feedbackResponseModal'));
  };

  const handleInputClick = (event) => {
    event.stopPropagation();
  };
  const clearForm = () => {
    setComplaintMap(true);
    location_ref.current.value = '';
    call_ref.current.value = '';
    content_ref.current.value = `${initial_content_ref}`;
    contentLen_ref.current.innerHTML = 0;
    // location_ref.current.focus();
    document.getElementById('_cont_loc').value = '';
  };

  const getMapLocation = () => {
    setSearchLoc(location_ref.current.value);
  };

  const divMap = useRef();
  const mapIb = useRef();
  const mapJb = useRef();
  const mapTmX = useRef();
  const mapTmY = useRef();

  const setComplaintMap = (bool) => {
    divMap.current.innerHTML = '';
    window.kakao.maps.load(function () {
      let typeText = '';
      let botChat = chatResult.data.filter((obj) => obj.chatType === 'bot');
      botChat = botChat.filter((obj) => obj.data.template_id);

      if (
        botChat[botChat.length - 1].data.messages[0] &&
        botChat[botChat.length - 1].data.messages[0].id === 'complaints_tem'
      ) {
        if (botChat[botChat.length - 1].data.messages[0].items[0]) {
          typeText =
            botChat[botChat.length - 1].data.messages[0].items[0].type.value;
        }
      }

      const defaultY = sessionStorage.getItem('latitude_y')
        ? parseFloat(sessionStorage.getItem('latitude_y'))
        : 37.240722;
      const defaultX = sessionStorage.getItem('longitude_x')
        ? parseFloat(sessionStorage.getItem('longitude_x'))
        : 127.177417;
      // const defaultY = sessionStorage.getItem('latitude_y') !== "" ? parseFloat(sessionStorage.getItem('latitude_y')) : (typeText === '공원가로등') ? 37.275856 : 37.240722;
      // const defaultX = sessionStorage.getItem('longitude_x') !== "" ? parseFloat(sessionStorage.getItem('longitude_x')) : (typeText === '공원가로등') ? 127.151277 : 127.177417;
      const mapContainer = divMap.current;
      const mapOption = {
        center: new window.kakao.maps.LatLng(defaultY, defaultX),
        level: 3,
      };

      const map = new window.kakao.maps.Map(mapContainer, mapOption);
      const zoomControl = new window.kakao.maps.ZoomControl();
      map.addControl(zoomControl, window.kakao.maps.ControlPosition.RIGHT);

      const geocoder = new window.kakao.maps.services.Geocoder();
      const marker = new window.kakao.maps.Marker();
      const infowindow = new window.kakao.maps.InfoWindow({ zindex: 1 });
      const ps = new window.kakao.maps.services.Places();
      let markers = [];

      function mapClickEvent(latLng) {
        bool = false;
        mapIb.current.value = latLng.getLng();
        mapJb.current.value = latLng.getLat();

        geocoder.transCoord(latLng.getLng(), latLng.getLat(), transCoordCB, {
          input_coord: window.kakao.maps.services.Coords.WGS84,
          output_coord: window.kakao.maps.services.Coords.WTM,
        });

        searchDetailAddrFromCoords(latLng);
      }

      function transCoordCB(result, status) {
        if (status === window.kakao.maps.services.Status.OK) {
          mapTmX.current.value = result[0].x;
          mapTmY.current.value = result[0].y;
        }
      }

      function searchDetailAddrFromCoords(coords) {
        geocoder.coord2Address(
          coords.getLng(),
          coords.getLat(),
          function (result, status) {
            setMapMarkerWithText(result, status, coords);
          }
        );
      }

      function setMapMarkerWithText(result, status, coords) {
        if (status === window.kakao.maps.services.Status.OK) {
          const addrText = result[0].road_address
            ? result[0].road_address.address_name
            : result[0].address.address_name;
          const addrNode = '<div class="text-all p1">' + addrText + '</div>';

          marker.setPosition(coords);
          marker.setMap(map);

          infowindow.setContent(addrNode);
          infowindow.open(map, marker);

          if (bool) {
            location_ref.current.value = '';
          } else {
            location_ref.current.value = addrText;
          }

          /*
          if (clearYN === 'Y') {
            location_ref.current.value = '';
            setClearYN('N');
          } else if (clearYN === 'N') {
            location_ref.current.value = addrText;
          }
          */

          setSelectedLoc(addrText);
          setSelectedRegion(
            result[0].road_address
              ? result[0].road_address.region_2depth_name
              : result[0].address.region_2depth_name
          );

          map.setCenter(coords);
        }
      }

      if (searchLoc !== '') {
        geocoder.addressSearch(searchLoc, function (result, status) {
          if (status === window.kakao.maps.services.Status.OK) {
            if (markers.length > 0) {
              for (let i = 0; i < markers.length; i += 1) {
                markers[i].setMap(null);
              }
            }
            markers = [];
            const bounds = new window.kakao.maps.LatLngBounds();

            for (let i = 0; i < result.length; i += 1) {
              const searchedCoords = new window.kakao.maps.LatLng(
                result[i].y,
                result[i].x
              );
              bounds.extend(searchedCoords);
              setMapMarkers(result[i], searchedCoords);
            }

            map.setBounds(bounds);
          }
        });
      } else {
        searchDetailAddrFromCoords(map.getCenter());
      }

      function setMapMarkers(result, coords) {
        const addrText = result.road_address_name
          ? result.road_address_name
          : result.address_name;
        const placeText = result.place_name ? result.place_name : addrText;
        const addrNode = '<div class="text-all p1">' + placeText + '</div>';

        const newMarker = new window.kakao.maps.Marker();
        newMarker.setPosition(coords);
        newMarker.setClickable(true);
        newMarker.setMap(map);

        // const infowindows = new kakao.maps.InfoWindow({ zindex: 1 });
        // infowindows.setContent(addrNode);
        // infowindows.open(map, newMarker);

        window.kakao.maps.event.addListener(newMarker, 'click', function () {
          infowindow.setContent(addrNode);
          infowindow.open(map, newMarker);
        });
        setSelectedLoc(addrText);
      }

      window.kakao.maps.event.addListener(map, 'click', function (mouseEvent) {
        const latLng = mouseEvent.latLng;
        mapClickEvent(latLng);
      });
    });
  };

  useEffect(() => {
    setComplaintMap(false);
  }, [searchLoc]);

  return (
    <div className='complaint_bg'>
      <div
        className='popup_loading_main'
        id='complaint_loading'
        style={{ display: 'none' }}
      >
        <span> 생활 불편신고를 접수중입니다...</span>
        <div
          className='loadingio-spinner-ripple-rrdcxdwt1hp'
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <div className='ldio-bl3f74ldijf'>
            <div />
            <div />
          </div>
        </div>
      </div>
      <div className='_box'>
        <div className='_top'>
          <div className='_tit'>민원접수하기</div>
          <div
            className='_close'
            onClick={() => endComplaint('민원접수취소', '민원 접수 취소')}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                endComplaint('민원접수취소', '민원 접수 취소');
              }
            }}
          >
            <IconButton
              icon='ri-close-line'
              styleDef={{
                width: '15px',
                fontSize: '30px',
                fontWeight: 100,
                position: 'absolute',
                top: '19px',
                right: '20px',
                height: '15px',
              }}
              label='닫기 버튼'
              tabIndex='2'
            />
          </div>
        </div>
        <div className='_middle'>
          <div
            className='_complaint_div'
            style={{
              height: '420px',
              overflowY: 'auto',
              padding: '0em 1.1em 0em 1.1em',
              paddingBottom: '1em',
            }}
          >
            <input
              type='hidden'
              id='mapIb'
              name='mapIb'
              defaultValue='126.97011924559922'
              ref={mapIb}
              tabIndex={1}
            />
            <input
              type='hidden'
              id='mapJb'
              name='mapJb'
              defaultValue='37.56293004790111'
              ref={mapJb}
              tabIndex={1}
            />
            <input
              type='hidden'
              id='mapTmX'
              name='mapTmX'
              defaultValue='197359.9999999998'
              ref={mapTmX}
              tabIndex={1}
            />
            <input
              type='hidden'
              id='mapTmY'
              name='mapTmY'
              defaultValue='451488.99999999953'
              ref={mapTmY}
              tabIndex={1}
            />

            <div className='_input_div'>
              <ul className='_item'>
                <li className='_label'>
                  <label htmlFor='btnSearchPost'>
                    <span className='text-danger'>* </span>신고 장소
                  </label>
                </li>
                <li className='_cont'>
                  <textarea
                    ref={location_ref}
                    id='_cont_loc'
                    placeholder='지도를 클릭하거나 주소를 입력하세요.'
                    autoComplete='off'
                    rows={2}
                    onKeyPress={onKeyPressEvt}
                    onChange={setTextareaLen}
                    tabIndex={1}
                  />
                  <input
                    id='btnSearchLoc'
                    type='button'
                    value='지도 검색'
                    onClick={getMapLocation}
                    className='post-btn'
                    tabIndex={1}
                  />
                </li>
              </ul>
              <div
                id='divMap'
                ref={divMap}
                className='w-100'
                style={{ height: '200px' }}
              />
              <ul className='_item'>
                <li className='_label'>
                  <label htmlFor='_cont_call'>
                    <span className='text-danger'>* </span>휴대폰번호
                  </label>
                </li>
                <li className='_cont'>
                  <input
                    onClick={handleInputClick}
                    onInput={(e) => {
                      if (e.target.value.length > e.target.maxLength) {
                        e.target.value = e.target.value.slice(
                          0,
                          e.target.maxLength
                        );
                      }
                    }}
                    ref={call_ref}
                    onKeyPress={onKeyPressEvt}
                    onKeyDown={(e) =>
                      ['e', 'E', '+', '-', '.'].includes(e.key) &&
                      e.preventDefault()
                    }
                    onWheel={(e) => e.target.blur()}
                    id='_cont_call'
                    type='number'
                    placeholder='- 없이 숫자로만 입력하세요.'
                    autoComplete='off'
                    inputMode='numeric'
                    pattern='[0-9]+'
                    maxLength={11}
                    tabIndex={1}
                  />
                </li>
                  <div style={{ marginTop: '-5px', textAlign: 'left' }}>
                    <span className='text-danger'>
                      휴대폰번호 오입력으로 민원내용 확인 통화 불가시 민원처리가 어려울 수 있습니다.
                    </span>
                  </div>
              </ul>
              <ul className='_item'>
                <li className='_label'>
                  <label htmlFor='_cont_type'>
                    <span className='text-danger'>* </span>유형
                  </label>
                </li>
                <li className='_cont'>
                  <input
                    type='hidden'
                    id='hid_main_type'
                    name='hid_main_type'
                    ref={main_type_ref}
                    tabIndex={1}
                  />
                  <input
                    type='hidden'
                    id='hid_type_code'
                    name='hid_type_code'
                    ref={type_code_ref}
                    tabIndex={1}
                  />
                  <input
                    ref={type_ref}
                    onKeyPress={onKeyPressEvt}
                    id='_cont_type'
                    type='text'
                    placeholder='유형을 입력하세요.'
                    autoComplete='off'
                    readOnly='readOnly'
                    className='text-read'
                    tabIndex={1}
                  />
                </li>
              </ul>
              <ul className='_item'>
                <li className='_label'>
                  <label htmlFor='_cont_content'>
                    내용(<span ref={contentLen_ref}>0</span>/1000자)
                  </label>
                </li>
                <li className='_cont'>
                  <textarea
                    ref={content_ref}
                    id='_cont_content'
                    placeholder='내용을 입력하세요.'
                    autoComplete='off'
                    rows={5}
                    className='r-none'
                    onChange={setTextareaLen}
                    tabIndex={1}
                  />
                  <div style={{ marginTop: '-10px', textAlign: 'left' }}>
                    <span className='text-danger'>
                      위 유형과 관련 없는 내용은 접수되지 않습니다.
                    </span>
                  </div>
                  <div style={{ marginTop: '0px', textAlign: 'left' }}>
                    <span className='text-danger'>
                      여러 유형의 민원은 유형별로 건건이 접수해 주시기 바랍니다.
                    </span>
                  </div>
                </li>
              </ul>
              <div className='border-bottom align-right'>
                <span className='text-danger'>*</span>은 필수 입력 항목입니다.
              </div>
              <ul className='_item'>
                <li className='_label'>
                  <input
                    id='_cont_agree_yes'
                    type='radio'
                    name='_cont_agree'
                    className='mr-1'
                    onChange={onAgreeChange}
                    tabIndex={1}
                    defaultValue='Y'
                  />
                  <label htmlFor='_cont_agree_yes'>
                    개인정보의 수집·이용에 대한 동의 (필수)
                  </label>
                </li>
                <div className='descText'>
                  1. 개인정보의 수집·이용 목적
                  <br />
                  - 생활불편 민원 접수 및 처리완료 문자안내를 위해 개인정보를
                  수집·이용 합니다.
                  <br />
                  <br />
                  2. 수집하는 개인정보의 항목
                  <br />
                  - 휴대폰번호
                  <br />
                  <br />
                  3. 개인정보의 보유 및 이용기간
                  <br />
                  - 1년
                  <br />
                  <br />
                  4. 동의를 거부할 권리가 있다는 사실과 동의 거부에 따른 불이익
                  내용
                  <br />- 이용자는 &ldquo;용인시 민원상담 챗봇시스템&rdquo;에서
                  수집하는 개인정보에 대해 동의를 거부할 권리가 있으며, 동의
                  거부 시에는 서비스 이용이 제한됩니다.
                </div>
              </ul>
              <div className='align-right'>
                <input
                  className='clearButton'
                  type='button'
                  value='입력 초기화'
                  onClick={clearForm}
                  tabIndex={1}
                />
              </div>
              <div>
                <div id='divAlert' className={alertClass}>
                  {alertText}
                </div>
                <NormalButton
                  label='민원접수'
                  styleDef={{
                    color: '#FFF',
                    background: '#BE314B',
                    height: '3em',
                    margin: '1em 0',
                    borderRadius: '5px',
                    fontWeight: 'bold',
                    border: '1px solid #BE314B',
                  }}
                  clickEvt={checkAgree}
                  tabIndex='1'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Complaint;
